import React from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
import { CTAButton } from '../components/CTAButton';
import { Book, Sparkles, MessageCircle, FileText, ShieldCheck } from 'lucide-react';
export function ValueStackSection() {
  return <section className="bg-cosmic-black relative z-10 py-16 px-6 border-y border-gold/20 shadow-[0_0_40px_rgba(201,168,76,0.1)]" data-id="element-328">
      <ScrollReveal className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-329">
        <h2 className="font-playfair text-gold text-4xl md:text-5xl font-bold leading-tight mb-4 text-center text-glow-gold" data-id="element-330">
          Everything You Are Receiving Tonight...
        </h2>

        <p className="text-lunar-white text-lg md:text-xl text-center mb-12 font-lato max-w-2xl" data-id="element-331">
          A complete subconscious recalibration system for the price of a
          coffee.
        </p>

        <div className="w-full max-w-3xl space-y-6 mb-16" data-id="element-332">
          {/* ITEM 1 — THE MAIN PRODUCT */}
          <div className="bg-cosmic-card border border-gold/50 rounded-2xl p-6 md:p-8 relative overflow-hidden shadow-[0_0_20px_rgba(201,168,76,0.15)]" data-id="element-333">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-bl-full pointer-events-none" data-id="element-334"></div>
            <div className="flex flex-col md:flex-row gap-6 items-start md:items-center" data-id="element-335">
              <div className="w-16 h-16 rounded-xl bg-cosmic-deep border border-gold/30 flex items-center justify-center flex-shrink-0" data-id="element-336">
                <Book className="w-8 h-8 text-gold" data-id="element-337" />
              </div>
              <div className="flex-grow" data-id="element-338">
                <h3 className="font-playfair text-2xl text-lunar-white font-bold mb-1" data-id="element-339">
                  THE MIDNIGHT MAGNET PROTOCOL
                </h3>
                <p className="text-gold text-sm font-semibold tracking-wider mb-3" data-id="element-340">
                  DIGITAL PDF GUIDE + MASTERY SCRIPTS
                </p>
                <p className="text-lunar-lavender text-sm leading-relaxed" data-id="element-341">
                  The 3rd-generation Sleep Script designed to bypass your
                  conscious resistance and rewrite your love story in the
                  7-minute Theta Window. Includes the Specific Person Script and
                  the Cord-Cutting Ritual.
                </p>
              </div>
              <div className="flex flex-col items-end flex-shrink-0 mt-4 md:mt-0 text-right" data-id="element-342">
                <p className="text-lunar-muted text-sm line-through mb-1" data-id="element-343">
                  Value: $47.00
                </p>
                <p className="text-gold font-bold text-xl" data-id="element-344">INCLUDED</p>
              </div>
            </div>
          </div>

          {/* ITEM 2 — BONUS #1 */}
          <div className="bg-cosmic-deep border border-violet/40 rounded-2xl p-6 md:p-8 relative overflow-hidden" data-id="element-345">
            <div className="absolute top-4 right-4 bg-gold text-cosmic-black text-xs font-bold px-3 py-1 rounded-full tracking-wider shadow-[0_0_10px_rgba(201,168,76,0.5)]" data-id="element-346">
              FREE BONUS
            </div>
            <div className="flex flex-col md:flex-row gap-6 items-start md:items-center mt-6 md:mt-0" data-id="element-347">
              <div className="w-16 h-16 rounded-xl bg-cosmic-card border border-violet/30 flex items-center justify-center flex-shrink-0" data-id="element-348">
                <Sparkles className="w-8 h-8 text-violet" data-id="element-349" />
              </div>
              <div className="flex-grow" data-id="element-350">
                <h3 className="font-playfair text-xl text-lunar-white font-bold mb-2" data-id="element-351">
                  THE THETA DREAM DECODER
                </h3>
                <p className="text-lunar-lavender text-sm leading-relaxed" data-id="element-352">
                  Stop wondering if it's working. This guide reveals the 3
                  specific types of dreams that prove your subconscious has
                  successfully accepted the new frequency. Get instant
                  validation the very first night.
                </p>
              </div>
              <div className="flex flex-col items-end flex-shrink-0 mt-4 md:mt-0 text-right" data-id="element-353">
                <p className="text-lunar-muted text-sm line-through mb-1" data-id="element-354">
                  Value: $19.00
                </p>
                <p className="text-gold font-bold text-xl" data-id="element-355">FREE</p>
              </div>
            </div>
          </div>

          {/* ITEM 3 — BONUS #2 */}
          <div className="bg-cosmic-deep border border-violet/40 rounded-2xl p-6 md:p-8 relative overflow-hidden" data-id="element-356">
            <div className="absolute top-4 right-4 bg-gold text-cosmic-black text-xs font-bold px-3 py-1 rounded-full tracking-wider shadow-[0_0_10px_rgba(201,168,76,0.5)]" data-id="element-357">
              FREE BONUS
            </div>
            <div className="flex flex-col md:flex-row gap-6 items-start md:items-center mt-6 md:mt-0" data-id="element-358">
              <div className="w-16 h-16 rounded-xl bg-cosmic-card border border-violet/30 flex items-center justify-center flex-shrink-0" data-id="element-359">
                <MessageCircle className="w-8 h-8 text-violet" data-id="element-360" />
              </div>
              <div className="flex-grow" data-id="element-361">
                <h3 className="font-playfair text-xl text-lunar-white font-bold mb-2" data-id="element-362">
                  THE SANCTUARY: DIRECT GUIDANCE
                </h3>
                <p className="text-lunar-lavender text-sm leading-relaxed" data-id="element-363">
                  You are not doing this alone. Gain exclusive digital access to
                  Lady Aristhéne's private support channel for guidance, ritual
                  tips, and collective frequency alignment with thousands of
                  women on the same path.
                </p>
              </div>
              <div className="flex flex-col items-end flex-shrink-0 mt-4 md:mt-0 text-right" data-id="element-364">
                <p className="text-lunar-muted text-sm line-through mb-1" data-id="element-365">
                  Value: $27.00
                </p>
                <p className="text-gold font-bold text-xl" data-id="element-366">FREE</p>
              </div>
            </div>
          </div>
        </div>

        {/* THE FINAL ANCHOR (Visual Summary) */}
        <div className="w-full max-w-3xl bg-gradient-to-b from-cosmic-card to-cosmic-black border-2 border-gold/30 rounded-3xl p-4 md:p-12 flex flex-col items-center relative shadow-[0_0_50px_rgba(201,168,76,0.1)]" data-id="element-367">
          {/* Bundle Mockup Image */}
          <div className="w-full max-w-xl mx-auto mb-10 relative rounded-xl overflow-hidden shadow-[0_0_30px_rgba(201,168,76,0.3)] border border-gold/20" data-id="element-368">
            <div className="absolute top-2 left-2 md:top-4 md:left-4 bg-cosmic-black/80 backdrop-blur-sm border border-gold/50 text-gold text-[10px] md:text-xs font-bold px-2 py-1 md:px-3 md:py-2 rounded-lg flex items-center gap-1 md:gap-2 z-10 shadow-lg" data-id="element-369">
              <FileText className="w-3 h-3 md:w-4 md:h-4" data-id="element-370" />
              DIGITAL EDITION (PDF)
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/dJDV1ReUTRCG7goNC13Ry1/ChatGPT_Image_17_mar_2026,_12_38_15_p.m..png" alt="The Midnight Magnet Bundle" className="w-full h-auto object-cover" data-id="element-371" />
          </div>

          {/* Value Box */}
          <div className="w-full bg-cosmic-deep border border-white/10 rounded-xl p-6 mb-8 text-center" data-id="element-372">
            <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-12" data-id="element-373">
              <div data-id="element-374">
                <p className="text-lunar-muted text-sm uppercase tracking-wider mb-1" data-id="element-375">
                  Total Real Value
                </p>
                <p className="text-2xl text-lunar-white line-through font-playfair" data-id="element-376">
                  $93.00
                </p>
              </div>
              <div className="hidden md:block w-px h-12 bg-white/10" data-id="element-377"></div>
              <div data-id="element-378">
                <p className="text-gold text-sm uppercase tracking-wider mb-1 font-bold" data-id="element-379">
                  Your Special Price
                </p>
                <p className="text-4xl text-gold font-bold font-playfair text-glow-gold" data-id="element-380">
                  $6.37
                </p>
              </div>
            </div>
            <div className="mt-6 inline-block bg-green-900/30 border border-green-500/50 text-green-400 font-bold px-6 py-2 rounded-full text-sm" data-id="element-381">
              You Save: $86.63 (93% OFF)
            </div>
          </div>

          {/* CTA */}
          <div className="w-full flex flex-col items-center" data-id="element-382">
            <CTAButton size="large" className="w-full md:w-auto mb-6" onClick={() => {
            // 2. BUTTON EVENT TRACKING: InitiateCheckout
            if (typeof (window as any).fbq === 'function') {
              ;
              (window as any).fbq('track', 'InitiateCheckout');
            }
            window.location.href = 'https://pay.hotmart.com/W104946771H?checkoutMode=10';
          }} data-id="element-383">
              🌙 CLAIM THE FULL BUNDLE FOR $6.37
            </CTAButton>

            <div className="bg-green-900/20 border border-green-500/30 rounded-lg p-4 w-full max-w-2xl" data-id="element-384">
              <p className="text-green-400 text-sm font-semibold flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-385">
                <span className="flex items-center" data-id="element-386">
                  <ShieldCheck className="w-4 h-4 mr-1" data-id="element-387" /> Bank-Level Security
                </span>
                <span className="hidden md:inline text-green-500/50" data-id="element-388">·</span>
                <span data-id="element-389">Instant Digital Download</span>
                <span className="hidden md:inline text-green-500/50" data-id="element-390">·</span>
                <span data-id="element-391">Access in 60 Seconds</span>
                <span className="hidden md:inline text-green-500/50" data-id="element-392">·</span>
                <span data-id="element-393">7-Day Money Back Guarantee</span>
              </p>
            </div>
          </div>
        </div>
      </ScrollReveal>
    </section>;
}